import { stripeActions } from "../../actionTypes";

const initialState = {
	subscription: {},
	fetching: false,
	fetched: false,
	error: null,
};

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case stripeActions.SWAP_STRIPE_SUBSCRIPTION: {
			return { ...initialState, fetching: true };
		}

		case stripeActions.SWAP_STRIPE_SUBSCRIPTION_FULFILLED: {
			return {
				...state,
				fetching: false,
				fetched: true,
				subscription: action.payload,
			};
		}

		case stripeActions.SWAP_STRIPE_SUBSCRIPTION_REJECTED: {
			return { ...state, fetching: false, error: action.payload };
		}

		default:
	}

	return state;
};

export default Reducer;
